export const wpClassNames = {
    INDENTED_TEXT: 'cdm-indented-text',
    INDENTED_TEXT_CONTAINER: 'indented-text-Container',
    INDENTED_TEXT_TITLE: 'wp-block-heading',
    INDENTED_TEXT_ICON: 'hideIcon'
}